import { Component } from 'react'
import '../BranchMangement/BranchListContainer.css'
import { Input, Container, Row, Col } from 'reactstrap'
import PermissionsList from "./PermissionsList"
import CreatePermissionModal from "./CreatePermissionModal"
import RestrictedSection from "../../Components/RestrictedSection"
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class PermissionsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            searchTerm: "",
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_permission">
                <Container fluid className="bos-listing-container">
                    <Row className="align-items-center">
                        <Col xs={4}>
                            <span className="driver-search-filter">
                                <Input type="text" name="searchTerm" placeholder="Search" onChange={this.updateInput} />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col xs="auto" className="p-0">
                            <AdvancedFiltersControl entity="permission" />
                        </Col>
                        <Col className="text-right">
                            <a className="driver-list-button" onClick={() => this.toggleModal("createPermission")}>
                                Create Permission | <i className="fa fa-user-plus" aria-hidden="true"></i>
                            </a>
                            {this.state.openModal === "createPermission" && <CreatePermissionModal handleClose={() => this.toggleModal("createPermission")} open={this.state.openModal === "createPermission"} />}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="mt-2 search-filter-container">
                            <AppliedAdvancedFilters entity="permission" context={null} />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <PermissionsList searchTerm={this.state.searchTerm ? this.state.searchTerm : ""} />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}


export default PermissionsListContainer

